import React from 'react';
import {
  View,
  Text,
  Image,
  Pressable,
  StyleSheet,
  Dimensions,
  Platform,
  Linking,
} from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';
import OPComponent from './op_component';
import Navigation from '../../navigation';
import I18n from '../../I18n';
import GestureRecognizer from './gesture_recognizer';

const GESTURE_CONFIG = {
  velocityThreshold: 0.3,
  directionalOffsetThreshold: 40,
};

export default class NewAppVersionPopup extends OPComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.autoDismissTimerSec) {
      setTimeout(this.close, this.props.autoDismissTimerSec * 1000);
    }
  }

  close = () => {
    Navigation.dismissInAppNotification(this.props.componentId);
  };

  handlePress = () => {
    Linking.openURL(this.props.link);
    this.close();
  };

  renderContents() {
    let { message, link } = this.props;

    return (
      <Pressable style={styles.button} onPress={this.handlePress}>
        <View style={styles.buttonInner}>
          <Image
            style={styles.iconImage}
            source={require('../../../resources/notification-icon-alert.png')}
          />
          <View style={styles.textContainer}>
            <Text numberOfLines={3} style={styles.bodyText}>
              {message}
              {'\n'}
            </Text>

            <Text style={[styles.bodyText, styles.linkStyle]}>
              {I18n.t('components.updateNow')}
            </Text>
          </View>
        </View>
      </Pressable>
    );
  }

  render() {
    let { height, width } = Dimensions.get('window');
    return (
      <View style={[styles.container, { width }]}>
        <GestureRecognizer onSwipeUp={this.close} style={{ flex: 1 }} config={GESTURE_CONFIG}>
          {this.renderContents()}
        </GestureRecognizer>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    height: 170,
    paddingTop: Platform.OS === 'ios' ? 25 : 0,
    backgroundColor: COLOR.contrast,
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
  },
  button: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 25,
  },
  buttonInner: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  iconImage: {
    width: 24,
    height: 23,
    tintColor: COLOR.emphasis,
  },
  textContainer: {
    flex: 1,
    paddingLeft: 25,
  },
  titleText: {
    marginBottom: 10,
    ...FONT.medium,
    fontSize: FONT_SIZE.small,
    color: COLOR.text,
  },
  bodyText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    color: COLOR.text,
  },
  linkStyle: THEME.linkStyle,
});
